export default "__VITE_ASSET__frMwbZkF__"